// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__mQF6i","footerCopy":"footer_footerCopy__qITGp"};